import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Button } from '@material-ui/core';
import clsx from 'clsx';

const useButtonStyles = makeStyles((theme) => ({
  buttonWrapper: {
    padding: theme.spacing(1),
  },
  gutterTop: {
    marginTop: theme.spacing(1),
  },
}));

function UButton({ children, gutterTop, ...buttonProps }) {
  const classes = useButtonStyles();

  return (
    <div className={clsx(classes.buttonWrapper, gutterTop ? classes.gutterTop : '')}>
      <Button
        {...buttonProps}
      >
        {children}
      </Button>
    </div>
  );
}

UButton.defaultProps = {
  gutterTop: true,
};

UButton.propTypes = {
  gutterTop: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default UButton;
